<template>
    <div class="row">
        <div class="col-12" v-if="request.data.type === 'withdrawal'">
            <!-- <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Withdrawal Information</label> -->
            <ul class="list-unstyled lh-7">
                <li class="d-flex justify-content-between align-items-center">
                    <span class="tx-color-03">Current Amount: </span>
                    <span class="tx-semibold tx-18">{{ currentAmount|toCurrency(request.currency) }}</span>
                </li>
                <li class="d-flex justify-content-between align-items-center">
                    <span class="tx-color-03">Withdrawal Amount: </span>
                    <span class="tx-semibold tx-orange tx-30">{{ request.data.amount|toCurrency(request.data.currency) }}</span>
                </li>
                <li class="d-flex justify-content-between align-items-center">
                    <span class="tx-color-03">Balance after withdrawal: </span>
                    <span class="tx-semibold tx-18">{{ request.data.remaining_amount|toCurrency(request.data.currency) }}</span>
                </li>
            </ul>

            <!-- <label class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03">Bank account to be credited</label>
            <ul class="list-unstyled lh-7">
                <li class="d-flex justify-content-between">
                    <span>Bank Name: </span>
                    <span class="tx-semibold">{{ bankAccountDetails.bank_details.name | placeholder }}</span>
                </li>
                <li class="d-flex justify-content-between">
                    <span>Branch: </span>
                    <span class="tx-semibold">{{ bankAccountDetails.branch_details.name | placeholder }}</span>
                </li>
                <li class="d-flex justify-content-between">
                    <span>Account Number: </span>
                    <span class="tx-semibold">{{ bankAccountDetails.account_number | placeholder }}</span>
                </li>
            </ul> -->
        </div>
    </div>
</template>

<script>
	export default {
		computed: {
			currentAmount: function() {
				const amount =
					parseFloat(this.request.data.amount) +
					parseFloat(this.request.data.remaining_amount);

				return amount;
			},
            bankAccountDetails() {
                return this.request.data.bank_account_details;

            }
		},
		props: ["request"]
	};
</script>